/* eslint-disable import/no-anonymous-default-export */

// reusable functions for custom cubemap reflections
export default /* glsl */`

  vec3 getOrthographicBoxReflectionUVW(vec3 reflectionDirection, vec3 previousReflectionDirection){
    vec3 commonReflectionVector = parallaxCorrectedNormal( reflectionDirection, boxProjectionSize, vec3(0.0), previousReflectionDirection);
    vec3 adjustmentScale = 1.0 / boxProjectionSize;
    return commonReflectionVector * adjustmentScale;
  }

`;